import { datadogRum } from "@datadog/browser-rum";

import { appEnv } from "src/const/appEnv";

export const initializeDatadogRum = () =>
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? "",
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.com",
    service: "patient",
    env: appEnv,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: appEnv === "production" ? 20 : 10,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: "mask",
  });
